import { render, staticRenderFns } from "./form-afm.vue?vue&type=template&id=33ae0314&scoped=true"
import script from "./form-afm.vue?vue&type=script&lang=js"
export * from "./form-afm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ae0314",
  null
  
)

export default component.exports